import { render, staticRenderFns } from "./PaymentPage.vue?vue&type=template&id=2924e04a&scoped=true"
import script from "./PaymentPage.vue?vue&type=script&lang=js"
export * from "./PaymentPage.vue?vue&type=script&lang=js"
import style0 from "./PaymentPage.vue?vue&type=style&index=0&id=2924e04a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2924e04a",
  null
  
)

export default component.exports